export default __webpack_public_path__ + "static/media/mobile2.34571c55.png";